module.exports = __webpack_public_path__ + "static/media/Overbite (deep bite)4.1e61eb43.png";